import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var LogIn = createReactComponent("LogIn", ["svg", defaultAttributes, [["path", {
  d: "M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4",
  key: "ji49vs"
}], ["polyline", {
  points: "10 17 15 12 10 7",
  key: "15i8xt"
}], ["line", {
  x1: "15",
  y1: "12",
  x2: "3",
  y2: "12",
  key: "wvjmef"
}]]]);
export default LogIn;